import React, { useEffect } from "react";
import {
  Grid,
  Typography,
  Container,
  Card,
  CardActionArea,
  CardContent,
  CardActions,
  Button,
  Grow,
  Icon,
} from "@material-ui/core";
import MagicHover from "magic-hover";
import bgImg from "../../assets/img/productCurvyLines.png";
import { Redirect, useHistory } from "react-router-dom";
import { LOCALE, changeLanguage } from "../../properties/Locale";
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/components/headerLinkStyle";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import { Alert, AlertTitle } from "@material-ui/lab";
import { AuthService } from "../auth/AuthService";
import { history } from "../..";

const useStyles = makeStyles(styles);

export default function PaymentResponseErrorComponent() {
  const [redirectTo, setRedirectTo] = React.useState();
  const [voucherTypes, setVoucherTypes] = React.useState();
  const [loading, setLoading] = React.useState(true);
  const classes = useStyles();
  const [openLanguage, setOpenLanguage] = React.useState(null);
  const [currentUser, setCurrentUser] = React.useState();

  const handleCloseLanguage = (item) => {
    if (item === "al") {
      setOpenLanguage(null);
      changeLanguage(item);
    } else {
      setOpenLanguage(null);
      changeLanguage(item);
    }
  };

  useEffect(() => {
    setCurrentUser(AuthService.getCurrentUser());
  }, []);

  return (
    <div
      style={{
        backgroundImage: "url(" + bgImg + ")",
        backgroundSize: "100% 100%",
        backgroundAttachment: "fixed",
        minHeight: "100vh",
      }}
    >
      {redirectTo && <Redirect to={redirectTo} push />}
      <Header />
      <Container>
        <Grid container spacing={2}>
          <Grid item md={12} sm={12} style={{ padding: "15px" }}>
            <Grid container spacing={4}>
              <Grow in={true} timeout={750}>
                <Grid item xs={12} md={12}>
                  <div style={{ textAlign: "center", marginTop: "100px" }}>
                    <Icon
                      fontSize="large"
                      style={{ fontSize: "5em" }}
                      color="secondary"
                    >
                      error
                    </Icon>
                    <p style={{ fontSize: "2em", fontWeight: "bold" }}>
                      {LOCALE.transaction_error}
                    </p>
                    <div style={{ textAlign: "center", marginTop: "25px" }}>
                      <Button
                        onClick={() => setRedirectTo("/orders")}
                        color="secondary"
                        size="small"
                        variant="contained"
                        style={{ marginTop: "30px" }}
                      >
                        Кон мои нарачки
                      </Button>
                    </div>
                  </div>
                </Grid>
              </Grow>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
